import React, { Component } from 'react'
import Swiper from 'swiper'
import { PrimaryH3, SecondaryP, StyledArrowDiv } from './styled-components.js'

export default class Carousel extends Component {
  componentDidMount() {
    new Swiper('.swiper-container', {
      direction: 'horizontal',
      loop: true,
      slidesPerView: 1,
      effect: 'fade',
      speed: 50,
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      keyboard: {
        enabled: true,
        onlyInViewport: false,
      },
      shortSwipes: false,
    })
  }

  render() {
    const { component } = this.props

    return (
      <section className={`component carousel margin-${component.marginBelow}`}>
        <div className="grid-row">
          <div className="col-12-12">
            <div className="outer-swiper-wrapper">
              <div className="swiper-container">
                <div className="swiper-wrapper">
                  {component.slides.map((slide, index) => {
                    return (
                      <div key={index} className="swiper-slide slide">
                        <div className="content-image swiper-button-next">
                          <img src={`${slide.image.file.url}`} />
                        </div>
                        <div className="content-description">
                          {slide.captionTitle && (
                            <PrimaryH3
                              primaryTextColor={component.primaryColor}
                              dangerouslySetInnerHTML={{
                                __html: slide.captionTitle,
                              }}
                            />
                          )}
                          {slide.captionCopy && (
                            <SecondaryP
                              secondaryTextColor={component.secondaryColor}
                              dangerouslySetInnerHTML={{
                                __html: slide.captionCopy.captionCopy,
                              }}
                            />
                          )}
                        </div>
                        <div className="slide-index">
                          <SecondaryP
                            secondaryTextColor={component.secondaryColor}
                            className="current-slide"
                          >
                            {getSlideCountDisplay(
                              index,
                              component.slides.length
                            )}
                          </SecondaryP>

                          <StyledArrowDiv
                            primaryStrokeColor={component.primaryColor}
                            secondaryStrokeColor={component.secondaryColor}
                            className="swiper-button-prev"
                          >
                            <div className="arrow left">
                              <ArrowSVG />
                            </div>
                          </StyledArrowDiv>

                          <StyledArrowDiv
                            primaryStrokeColor={component.primaryColor}
                            secondaryStrokeColor={component.secondaryColor}
                            className="swiper-button-next"
                          >
                            <div className="arrow right">
                              <ArrowSVG />
                            </div>
                          </StyledArrowDiv>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

function getSlideCountDisplay(index, length) {
  let slide = index + 1
  return getTwoDigits(slide) + ' / ' + getTwoDigits(length)
}

function getTwoDigits(number) {
  return (number < 10 ? '0' : '') + number
}

const ArrowSVG = () => (
  <svg
    width="22px"
    height="14px"
    viewBox="0 0 22 14"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="carousel-arrow" stroke="none" strokeWidth="1" fill="none">
      <g id="arrow-button">
        <g transform="translate(10.500000, 7.000000) rotate(-180.000000) translate(-10.500000, -7.000000)">
          <polyline points="14 0.384 20.583 6.967 14 13.55" />
          <path d="M-5.33054845e-12,7 L20.448,7" />
        </g>
      </g>
    </g>
  </svg>
)



// WEBPACK FOOTER //
// ./src/components/shared-page-components/carousel.js